import axios from 'axios';
import {
  DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_BEGIN,
  DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_SUCCESS,
  DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_FAILURE,
  DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadDbExportRequestList(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_BEGIN,
    });

    const header = builderSurfaceJsonContentHeader(args.projectId, true);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/db-export`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadDbExportRequestListError() {
  return {
    type: DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_BEGIN:
      return {
        ...state,
        loadDbExportRequestListPending: true,
        loadDbExportRequestListError: null,
      };

    case DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_SUCCESS:
      return {
        ...state,
        loadDbExportRequestListPending: false,
        loadDbExportRequestListError: null,
        DbExportRequestList: action.data,
      };

    case DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_FAILURE:
      return {
        ...state,
        loadDbExportRequestListPending: false,
        loadDbExportRequestListError: action.data.error,
      };

    case DEPLOYMENT_SETTING_LOAD_DB_EXPORT_REQUEST_LIST_DISMISS_ERROR:
      return {
        ...state,
        loadDbExportRequestListError: null,
      };

    default:
      return state;
  }
}
